import component from "./DrawLotModalContent";

export default component;
